import React, { useState } from 'react';
import { FaTimesCircle } from 'react-icons/fa';

export default function CancellationsModal({ onClose, cancelledShifts, cancelledLeaves }) {
    const [activeTab, setActiveTab] = useState('shifts');

    const renderShift = (shift) => {
        // Assume shift has: date, startTime, endTime, cancelReason, cancelledBy
        return (
            <div key={shift.id} style={styles.listItem}>
                <FaTimesCircle style={styles.icon} />
                <div style={styles.itemDetails}>
                    <div style={styles.itemTitle}>
                        {shift.type || 'Day'} • {shift.date} {shift.startTime} &rarr; {(shift.endDate || shift.date)} {shift.endTime}
                    </div>
                    <div style={styles.itemMeta}>
                        Reason: {shift.cancelReason || 'Not specified'}<br/>
                        By: {shift.cancelledBy || 'System'}
                    </div>
                </div>
            </div>
        );
    };

    const renderLeave = (leave) => {
        return (
            <div key={leave.id} style={styles.listItem}>
                <FaTimesCircle style={styles.icon} />
                <div style={styles.itemDetails}>
                    <div style={styles.itemTitle}>
                        {leave.type || 'Annual'} • {leave.startDate} &rarr; {leave.endDate}
                    </div>
                    <div style={styles.itemMeta}>
                        Reason: {leave.cancelReason || 'Not specified'}<br/>
                        By: {leave.cancelledBy || 'System'}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <h2 style={styles.title}>Cancelled shifts and leave</h2>
                    <button onClick={onClose} style={styles.closeBtn}>&times;</button>
                </div>
                
                <div style={styles.tabsContainer}>
                    <button 
                        style={{ ...styles.tabBtn, ...(activeTab === 'shifts' ? styles.activeTab : styles.inactiveTab) }}
                        onClick={() => setActiveTab('shifts')}
                    >
                        Shifts
                    </button>
                    <button 
                        style={{ ...styles.tabBtn, ...(activeTab === 'leave' ? styles.activeTab : styles.inactiveTab) }}
                        onClick={() => setActiveTab('leave')}
                    >
                        Leave
                    </button>
                </div>

                <div style={styles.content}>
                    {activeTab === 'shifts' ? (
                        cancelledShifts && cancelledShifts.length > 0 ? (
                            cancelledShifts.map(renderShift)
                        ) : (
                            <div style={styles.emptyText}>No cancelled shifts found.</div>
                        )
                    ) : (
                        cancelledLeaves && cancelledLeaves.length > 0 ? (
                            cancelledLeaves.map(renderLeave)
                        ) : (
                            <div style={styles.emptyText}>No cancelled leave found.</div>
                        )
                    )}
                </div>

                <div style={styles.footer}>
                    <button style={styles.exportBtn} onClick={() => alert('Exporting data...')}>Export</button>
                    <button onClick={onClose} style={styles.cancelBtn}>Close</button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 1000
    },
    modal: {
        backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '700px',
        maxHeight: '90vh', display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)'
    },
    header: {
        padding: '24px 24px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    title: {
        margin: 0, fontSize: '18px', color: '#111827', fontWeight: 'bold'
    },
    closeBtn: {
        background: 'none', border: 'none', fontSize: '24px', color: '#9ca3af', cursor: 'pointer', lineHeight: 1
    },
    tabsContainer: {
        display: 'flex', borderBottom: '1px solid #e5e7eb', padding: '0 24px'
    },
    tabBtn: {
        flex: 1, padding: '12px 0', border: 'none', background: 'none', cursor: 'pointer', fontWeight: '500', fontSize: '14px'
    },
    activeTab: {
        color: '#0056b3', borderBottom: '2px solid #0056b3'
    },
    inactiveTab: {
        color: '#9ca3af', borderBottom: '2px solid transparent'
    },
    content: {
        padding: '24px', overflowY: 'auto', flex: 1, minHeight: '300px'
    },
    listItem: {
        display: 'flex', alignItems: 'flex-start', marginBottom: '16px', paddingBottom: '16px', borderBottom: '1px solid #f3f4f6'
    },
    icon: {
        color: '#9ca3af', fontSize: '20px', marginTop: '2px', marginRight: '16px'
    },
    itemDetails: {
        flex: 1
    },
    itemTitle: {
        fontSize: '14px', color: '#111827', fontWeight: '500', marginBottom: '4px'
    },
    itemMeta: {
        fontSize: '13px', color: '#6b7280', lineHeight: 1.5
    },
    emptyText: {
        textAlign: 'center', color: '#6b7280', marginTop: '40px'
    },
    footer: {
        padding: '16px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    exportBtn: {
        padding: '8px 16px', border: 'none', background: 'none', color: '#3b82f6', fontWeight: '500', cursor: 'pointer'
    },
    cancelBtn: {
        padding: '8px 16px', border: 'none', background: 'none', color: '#3b82f6', fontWeight: '500', cursor: 'pointer'
    }
};
